"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detail = void 0;
const timezone_enum_1 = __importDefault(require("timezone-enum"));
const Alignment_1 = require("../../enums/Alignment");
const GameCenterStatusType_1 = require("../../enums/game-center/GameCenterStatusType");
const game_center_asset_1 = require("../../utils/game-center-asset");
exports.detail = {
    name: 'New Game Center',
    status: GameCenterStatusType_1.GameCenterStatusType.DRAFT,
    startDate: null,
    endDate: null,
    timeZone: timezone_enum_1.default['Europe/Stockholm'],
    backgroundImage: (0, game_center_asset_1.getGameCenterAssetUrl)('game-center-background.png'),
    backgroundColor: 'FFFFFF',
    font: 'bebas',
    textColor: 'FFFFFF',
    exitButtonImage: (0, game_center_asset_1.getGameCenterAssetUrl)('close.png'),
    lockImage: (0, game_center_asset_1.getGameCenterAssetUrl)('lock.png'),
    webBackgroundImage: (0, game_center_asset_1.getGameCenterAssetUrl)('website-bg.png'),
    webBackgroundColor: 'FFFFFF',
    numberOfTotalModules: 0,
    logoImage: (0, game_center_asset_1.getGameCenterAssetUrl)('logo-cc.png'),
    logoAlignment: Alignment_1.Alignment.CENTER,
    headerTitle: 'Your wallet',
    headerTitleStyle: {
        font: 'bebas',
        color: 'FFFFFF',
        fontSize: '24px',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    isWalletActive: true,
    currencyImage: (0, game_center_asset_1.getGameCenterAssetUrl)('coin.png'),
    currencyTextColor: 'FFFFFF',
    lockTextColor: 'FFFFFF',
    dailyCoinsLimit: 500,
    gamificationId: null,
};
